import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../../hoc";
import "./DescriptionKids.css";
import TextDescription from "./TextDescriptionKids";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
import { RingLoader } from "react-spinners"; // Import the spinner component from react-spinners

const DescriptionKids = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true); // State variable to control loading
  const headingsData = [
    {
      level: 2,
      text: "Problem",
      id: "Problem",
    },
    {
      level: 2,
      text: "Current solutions",
      id: "Current-solutions",
    },
    {
      level: 2,
      text: "Affected populations",
      id: "Affected-populations",
    },
    {
      level: 2,
      text: "Our solution",
      id: "Our-solution",
    },
    {
      level: 3,
      text: "A Live Biological Therapeutics that effectively targets and reduces cadmium absorption in the human gut",
      id: "Solution",
    },
    {
      level: 3,
      text: "Mucus binding protein ",
      id: "mucus",
    },
    {
      level: 3,
      text: "Cadmium binding protein",
      id: "cadmium-binding",
    },

    {
      level: 2,
      text: "Additional health precautions",
      id: "health",
    },

    {
      level: 3,
      text: "Zinc & Iron",
      id: "Zinc",
    },

    {
      level: 3,
      text: "Horizontal Gene Transfer",
      id: "HGT",
    },

    {
      level: 2,
      text: "Engagement with the community",
      id: "Engagement",
    },

    {
      level: 3,
      text: "Education",
      id: "Education",
    },

    {
      level: 3,
      text: "Human Practices",
      id: "Hp",
    },
    {
      level: 3,
      text: "Sustainability",
      id: "Sustainability",
    },

    {
      level: 2,
      text: "Future perspectives",
      id: "Future",
    },

    {
      level: 2,
      text: "References",
      id: "references",
    },
  ];

  useEffect(() => {
    // Simulate a delay (remove this in your actual implementation)
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setDisplayNavBar(!loading);
  }, [loading, setDisplayNavBar]);

  return (
    <div className="relative">
      {loading ? ( // Conditionally render spinner or content based on loading state
        <div className="spinner-container">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          {/* Use BarLoader from react-spinners */}
        </div>
      ) : (
        <>
          <div className="top-page">
            <h1>Description</h1>
          </div>

          <div
            className="grid grid-cols-12 gap-4"
            style={{ marginRight: "50px", marginLeft: "50px" }}
          >
            <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
              <div className="sticky top-4 scrollable">
                <TableOfContents headings={headingsData} />
              </div>
            </div>
            <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
              <React.StrictMode>
                <TextDescription />
              </React.StrictMode>
            </main>
            <div className="md:hidden col-span-12 order-3 TOCstyle">
              <TocMobile headings={headingsData} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SectionWrapper(DescriptionKids, "descriptionkids");
